export {default as ProductDetail} from './container'


// WEBPACK FOOTER //
// ./src/features/product/productDetail/index.js